wbApp.controller('GroupsCtrl', ['$scope', '$modal', 'groupSvc',
function ($scope, $modal, groupSvc) {

    $scope.$on('refreshData', function (e, data) {
        $scope.groups = groupSvc.getAllAsync();
    });

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.groups = groupSvc.getAllAsync();

    $scope.gridOptions = {
        columnDefs: [{ field: 'name', displayName: "TXT_LBL_NAME", sort: 'locale', width: '250px' },
                     { field: 'description', displayName: "TXT_LBL_DESCRIPTION", sort: 'locale' },
                     { field: 'color', displayName: "TXT_LBL_COLOR", cellFilter: 'wbColor', width: '70px', html: true },
        ]
    };

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.groups;
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.groups;
            detailDialogPromise.$scope.model = groupSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        groupSvc.remove(data, null, null, $scope.groups);
    }
    
    var detailDialogPromise = $modal({
        templateUrl: 'users/groups/groups-detail.html',
        show: false,
        scope: $scope.$new()
    });
    

}]);
